import React from "react";
import styles from "./stats.module.css";
import useCountUp from "../../../../UTILS/HOOKS/useCountUp";
import { statistics } from "../../../../CONTENT/home";

const Stat = ({ value, suffix, label }) => {
  const [count, ref] = useCountUp(value);
  return (
    <div className={styles.stat} ref={ref}>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.value}>
        <span aria-hidden="true">
          {count}
          {suffix}
        </span>
        <span className={styles.srOnly}>
          {value}
          {suffix}
        </span>
      </dd>
    </div>
  );
};

const StatisticsSection = () => (
  <section className={styles.strip} aria-label="KUR at a glance">
    <dl className={styles.list}>
      {statistics.map((s) => (
        <Stat key={s.label} {...s} />
      ))}
    </dl>
  </section>
);

export default StatisticsSection;
